/* External dependencies */
import { Epic, ofType } from 'redux-observable';
import { from, of, timer, concat } from 'rxjs';
import { switchMap, mergeMap, catchError, map } from 'rxjs/operators';
import { Action } from 'redux';

/* Local dependencies */
import { verifyDeviceRequest } from './service';
import {
  VerifyDeviceActionTypes,
  verifyDeviceSuccess,
  verifyDeviceFailure,
  VerifyDeviceAction,
} from './acrions';
import { VerifyDeviceInput, Device } from '../../types';
import { listDevice } from '../../list-device/redux/actions';
import { RootState } from '../../../../redux/store';
import { getUserRequestActionWihtId } from '../../../users/get-user/redux/action';

export const verifyDeviceEpic: Epic<Action, Action, RootState> = (action$) =>
  action$.pipe(
    ofType(VerifyDeviceActionTypes.VERIFY_DEVICE_REQUEST),
    switchMap((action: VerifyDeviceAction) =>
      from(verifyDeviceRequest(action.payload)).pipe(
        mergeMap((device: Device) => 
          concat(
            from([
              verifyDeviceSuccess(device),
              listDevice()
            ]),
            timer(1000).pipe(
              map(() => getUserRequestActionWihtId(device.user.id))
            )
          )
        ),
        catchError((error) => of(verifyDeviceFailure(error)))
      ),
    ),
  ); 